(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2b58"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2b58"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gm4sb", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $be8227c7ee2b94f0$export$6503ec6e8aabbaf; }, function (v) { return $be8227c7ee2b94f0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $be8227c7ee2b94f0$export$f7ad0328861e2f03; }, function (v) { return $be8227c7ee2b94f0$export$f7ad0328861e2f03 = v; });
var $be8227c7ee2b94f0$export$6503ec6e8aabbaf;
var $be8227c7ee2b94f0$export$f7ad0328861e2f03;
"use strict";
var $be8227c7ee2b94f0$var$mapping = new Map();
function $be8227c7ee2b94f0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$be8227c7ee2b94f0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $be8227c7ee2b94f0$var$resolve(id) {
    var resolved = $be8227c7ee2b94f0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$be8227c7ee2b94f0$export$6503ec6e8aabbaf = $be8227c7ee2b94f0$var$register;
$be8227c7ee2b94f0$export$f7ad0328861e2f03 = $be8227c7ee2b94f0$var$resolve;

});

parcelRegister("5waPY", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $404858fdeb70fa97$export$bdfd709ae4826697; }, function (v) { return $404858fdeb70fa97$export$bdfd709ae4826697 = v; });
var $404858fdeb70fa97$export$bdfd709ae4826697;
var $404858fdeb70fa97$export$c9e73fbda7da57b6;
var $404858fdeb70fa97$export$5a759dc7a1cfb72a;
"use strict";
var $404858fdeb70fa97$var$bundleURL = {};
function $404858fdeb70fa97$var$getBundleURLCached(id) {
    var value = $404858fdeb70fa97$var$bundleURL[id];
    if (!value) {
        value = $404858fdeb70fa97$var$getBundleURL();
        $404858fdeb70fa97$var$bundleURL[id] = value;
    }
    return value;
}
function $404858fdeb70fa97$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $404858fdeb70fa97$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $404858fdeb70fa97$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $404858fdeb70fa97$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$404858fdeb70fa97$export$bdfd709ae4826697 = $404858fdeb70fa97$var$getBundleURLCached;
$404858fdeb70fa97$export$c9e73fbda7da57b6 = $404858fdeb70fa97$var$getBaseURL;
$404858fdeb70fa97$export$5a759dc7a1cfb72a = $404858fdeb70fa97$var$getOrigin;

});

var $09ef412e44c3a199$exports = {};


(parcelRequire("gm4sb")).register((parcelRequire("5waPY")).getBundleURL("aK4Nu"), JSON.parse('["aK4Nu","index.da2d6fa9.js","8Jql3","ccip.a3433b19.js","hxcd6","Wave.2a680c9e.svg","1s3OD","Wave2.22db6b94.svg","4FeDo","Wave3.ea6ec40e.svg","cikrI","dist.04fecdbd.js","iruWC","dist.62d1ddbd.js","2To9q","dist.b89f256a.js","03t25","index.es.0303c3f2.js","j8aHQ","dist.69af7c20.js","63AfG","dist.de22a45c.js","59VWj","ArbitrumLogo.4a7518b6.svg","ablk1","AvalancheLogo.ad53a0d0.svg","cNCcP","BaseLogo.e87313d9.svg","am2xB","BAT.1212afba.svg","i4U6j","BNBLogo.3dada3dc.svg","35SNV","BTCLogo.5558c6c7.svg","7At62","BUSDLogo.a70524b3.svg","8Gqqf","Doge.9d700487.png","VfbD8","DogeLogo.58faeab6.svg","gtKRT","DOT.7e599be5.svg","1AToi","EthLogo.b15259c3.svg","1Vw6j","LitecoinLogo.f8fad246.svg","b74V2","OptimismLogo.4bfae879.svg","1oFQ8","PolygonLogo.7d5d4b87.svg","8FNwQ","Solana.47b69164.svg","4wOfM","TetherLogo.85e85692.svg","5GYUQ","TronLogo.a023c6a9.svg","cEFpN","USDCLogo.08b3a902.svg","2KVtv","EURCLogo.3ca41448.svg","fYjZK","XMRLogo.26608d9e.svg","1YHAY","EUROLogo.d27285e3.svg","f389o","GBPLogo.18d6f7a0.svg","jcck8","BCHLogo.b63c073e.svg","dsuua","esm.ed32fc46.js","6uGNf","esm.98a1fd01.js","lgVp5","de_3.a3625524.png","42Aq7","nl_3.d58cedc9.png","4Lrty","fr_3.5245a318.png","8Y8t2","es_3.ad2f5d9f.png","d1O0F","pt_3.7cd5ed24.png","9FtIq","pl_3.71278cad.png","bGxDY","sk_3.356463f5.png","PoMeW","uk_3.f58a4276.png","1mMAD","index.b692f881.css"]'));

})();
//# sourceMappingURL=index.runtime.ba9d67fb.js.map
